import HttpRepository from './httpRepository'

export default class EventLotteryRepository extends HttpRepository {
  getLottery(id) {
    return this.get(`/v1/lottery/index/${id}`)
  }

  getCampaignInfo(campaignId) {
    return this.get(`/v1/campaign/lottery/${campaignId}`)
  }

  lottery({ campaignId, codes, castId, extraInfo, fanClubNumber, tobeId }) {
    const params = new URLSearchParams()
    params.append('campaign_id', campaignId)
    if (codes) {
      params.append('codes', codes)
    }
    if (castId) {
      params.append('cast_id', castId)
    }
    if (extraInfo) {
      params.append('extra_info', extraInfo)
    }
    // Number_i FC会員番号 / TOBE ID (campaign_id=4060 のみ送る)
    if (fanClubNumber) {
      params.append('number_i_fan_club_number', fanClubNumber)
    }
    if (tobeId) {
      params.append('number_i_tobe_id', tobeId)
    }

    return this.post('/v1/lottery', params)
  }

  // Number_i FC会員番号 / TOBE ID の事前検証(campaign_id=4060)。応募ページで「次へ」を押した時点に呼び、
  // 応募時と同じ正規化・検証を BE で行う(応募はしない)。
  // 200: { fan_club_number, tobe_id }(正規化後の値) / 400: { error, field: 'fanClubNumber' | 'tobeId' }
  validateNumberIFcTobe({ campaignId, fanClubNumber, tobeId }) {
    const params = new URLSearchParams()
    params.append('campaign_id', campaignId)
    params.append('number_i_fan_club_number', fanClubNumber)
    params.append('number_i_tobe_id', tobeId)

    return this.post('/v1/lottery/validate_number_i_fc_tobe', params)
  }

  confirm() {
    return this.get('/v1/lottery/confirm')
  }

  twice4({ castId, code }) {
    const params = new URLSearchParams()
    params.append('cast_id', castId)
    params.append('code', code)

    return this.post('/v1/lottery/twice4', params)
  }
}
